import React from 'react';

function NoFilter() {
    // Use a hidden control to take the space to match other filter controls
    return (
        <input className="form-control form-control-sm invisible" />
    )
}

export default NoFilter;